import {exeRequest} from '../utils/APIUtils'

export default {
    //get : async  (dates, concessionnaireId) => exeRequest(`/chiffre-affaires?dateDebut=2023-04-01&dateFin=2023-12-31&concessionnaireId=${concessionnaireId}`, "GET")
    get : async  (dates, concessionnaireId) => exeRequest(`/chiffre-affaires?dateDebut=${dates.debut}&dateFin=${dates.fin}&concessionnaireId=${concessionnaireId}`, "GET")
}